const BRIDGE_NAME = {
    SEND_NOTIFICATION: 'sendNotification',
    GET_LOGIN_INFO: 'getLoginInfo',
    JUMP_TO_VIEW: 'jumpToView',
    CLOSE_PAGE: 'closePage',
    GET_NOTIFICATION_SETTINGS: 'getNotificationSettings',
    OPEN_APPLICATION_SETTING: 'openApplicationSetting',
    UPLOAD_LICENSE: 'uploadLicense',
    POST_UGC: 'postUGC',
    SEND_COMMENT: 'sendComment',
    COMMUNITY_ADD_MEMBERS: 'communityAddMembers',
    GO_MAP: 'goToMap',
    SHOW_SELECTOR: 'showSelector',
    SHOW_LOADING: 'startNativeLoading',
    DESTROY_LOADING: 'stopNativeLoading',
    GET_CONTENT_FROM_USER: 'getContentFromUser',
    REQUEST_EVENT: 'requestEvent',
    TOUCH_SLOP: 'touchSlop',
    SAVE_PHOTOS_ALBUM: 'savePhotosAlbum',
    GET_DEVICE_INFO: 'deviceInfo',
    SHOW_IMAGE_GALLERY: 'showImgGallery',
    IMAGE_PICKER: 'imagePicker',
    SHARE_GROUP_RANK: 'shareGroupRank',
    VIDEO_DOWNLOAD: 'videoDownload',
    APPLY_JOIN_GROUP: 'applyJoinGroup'
};

const SCHEMA = {
    // nio://scam/report?resourceID=xxx&resourceType=xxx&scamUserId=xxx
    // 其中：scamUserId为群主id/被举报内容作者id，当resourceType为群时必填，H5不会用到。
    report: {
        name: 'nio://scam/report',
        version: {
            ios: '3.8.5',
            android: '3.8.5'
        }
    },
    // nio://mall/order.confirm?data=xxx
    // 其中：data = encodeURIComponent(
    // '{
    //    "goods_skus": [{
    //         "sku_code": "xxxxxxxx",
    //         "amount": 1
    //    }],
    //    "giftType": "30",
    //    "signInType ": "100"
    // }')
    goods: {
        name: 'nio://mall/order.confirm',
        version: {
            ios: '3.9.7',
            android: '3.9.7'
        }
    },
    // 'nio://ugc/detail?type=ugc_post&id=1234' ugc 详情页
    ugc: {
        name: 'nio://ugc/detail'
    },
    // 'nio://community/members?id=xxxx' 社群：成员列表scheme
    communityMember: {
        name: 'nio://community/members',
        version: {
            ios: '3.9.13',
            android: '3.9.13'
        }
    },
    // 'nio://community/activities?id=xxxx' 社群：活动列表scheme
    communityActivities: {
        name: 'nio://community/activities',
        version: {
            ios: '3.9.13',
            android: '3.9.13'
        }
    },
    // 'nio://community/info?id=xxxx' 社群：设置页scheme
    communitySetting: {
        name: 'nio://community/info',
        version: {
            ios: '3.9.13',
            android: '3.9.13'
        }
    },
    // nio://conversation?id=xxx&name=xxx&type=xxx
    conversation: {
        name: 'nio://conversation'
    },
    friendInfo: {
        name: 'nio://friend/info'
    },
    // 'nio://activity/evaluation/dialog?id=${activityId}&${queryId}=${id}&type=activity&appointment_id=${registrationId}&affect=${affect}' 活动评价
    activityEvaluation: {
        name: 'nio://activity/evaluation/dialog'
    },
    // nio://post/comment/publish?resourceID=${ activityId }&resourceType=activity 评论发表页
    postComment: {
        name: 'nio://post/comment/publish'
    },
    // nio://friend/info?userID=id 个人主页
    friend: {
        name: 'nio://friend/info'
    },
    // nio://community/topic?id=id 话题主页
    topic: {
        name: 'nio://community/topic'
    },
    // nio://lbs/details?poi_id=id lbs页面
    lbs: {
        name: 'nio://lbs/details'
    }
};

const BRIDGE_VERSION = {
    [BRIDGE_NAME.SEND_NOTIFICATION]: {
        ios: '2.9.5',
        android: '2.9.5'
    },
    [BRIDGE_NAME.GET_NOTIFICATION_SETTINGS]: {
        ios: '3.4.5'
    },
    [BRIDGE_NAME.OPEN_APPLICATION_SETTING]: {
        ios: '3.4.5'
    },
    [BRIDGE_NAME.UPLOAD_LICENSE]: {
        ios: '3.6.0',
        android: '3.6.0'
    },
    [BRIDGE_NAME.POST_UGC]: {
        ios: '3.9.5',
        android: '3.9.5'
    },
    [BRIDGE_NAME.COMMUNITY_ADD_MEMBERS]: {
        ios: '3.9.13',
        android: '3.9.13'
    },
    [BRIDGE_NAME.SHOW_LOADING]: {
        ios: '3.9.13',
        android: 'unknown'
    },
    [BRIDGE_NAME.DESTROY_LOADING]: {
        ios: '3.9.13',
        android: 'unknown'
    },
    [BRIDGE_NAME.GET_CONTENT_FROM_USER]: {
        ios: '3.10.2',
        android: '3.10.2'
    },
    [BRIDGE_NAME.REQUEST_EVENT]: {
        ios: 'unknown',
        android: '3.9.13'
    },
    [BRIDGE_NAME.TOUCH_SLOP]: {
        ios: 'unknown',
        android: '3.9.13'
    },
    [BRIDGE_NAME.SAVE_PHOTOS_ALBUM]: {
        ios: '3.10.2',
        android: '3.10.2'
    },
    [BRIDGE_NAME.GET_DEVICE_INFO]: {
        ios: '3.12.0'
    },
    [BRIDGE_NAME.IMAGE_PICKER]: {
        android: '4.2.0',
        ios: '4.2.0'
    },
    [BRIDGE_NAME.APPLY_JOIN_GROUP]: {
        android: '5.18.0',
        ios: '5.18.0'
    }
};

const BRIDGE_STATUS = {
    DONE: 'done',
    WRONG_VERSION: 'wrong_version',
    NO_BRIDGE: 'no_bridge',
    WRONG_PARAMS: 'wrong_params'
};

export { BRIDGE_NAME, SCHEMA, BRIDGE_VERSION, BRIDGE_STATUS };



// WEBPACK FOOTER //
// ./src/util/jsbridge/bridge-const.js